/* eslint-disable @typescript-eslint/no-explicit-any */

import { IJsonQuery, EDealType, EOfferType } from '../../utils/jsonQuery';
import { FilterOfferTypeContainer } from '../../containers/FilterOfferTypeContainer';
import { FilterPriceContainer } from '../../containers/FilterPriceContainer';
import { FilterGeoContainer } from '../../containers/FilterGeoContainer';
import { isAvailable } from '../../utils/jsonQuery/isAvailable';

export interface IFilter {
  availability(jsonQuery: IJsonQuery): boolean;
  clear?(jsonQuery: IJsonQuery): IJsonQuery;
  component: React.ComponentType<{ offerType?: EOfferType; dealType?: EDealType }>;
}

export type TFilterField = 'offerType' | 'price' | 'geo';

export type IAvailableFilters = Record<TFilterField, IFilter>;

export const FILTERS: IAvailableFilters = {
  offerType: {
    availability: isAvailable(EDealType.Any, EOfferType.Any),
    component: FilterOfferTypeContainer,
  },
  price: {
    availability: isAvailable(EDealType.Any, EOfferType.Any),
    component: FilterPriceContainer as any,
  },
  geo: {
    availability: isAvailable(EDealType.Any, EOfferType.Any),
    component: FilterGeoContainer as any,
  },
};

export const FILTERS_TYPES: Record<EDealType, TFilterField[]> = {
  [EDealType.Unexpected]: [],
  [EDealType.Sale]: ['offerType', 'price', 'geo'],
  [EDealType.RentLongterm]: ['offerType', 'price', 'geo'],
  [EDealType.RentDaily]: [],
  [EDealType.Rent]: [],
  [EDealType.Any]: [],
};
